export default __webpack_public_path__ + "static/media/notification-bell-outline-16px.f91362f7.svg";